export type BookingsToEditSortColumn = 'createdAt' | 'refCode' | 'hotelName' | 'clientCompany' | 'eventDate' | 'status' | null;

export type BookingsToEditSortDirection = 'asc' | 'desc';

export interface BookingsListSortState {
  sortColumn: BookingsToEditSortColumn;
  sortDirection: BookingsToEditSortDirection;
}

export const defaultBookingsListSortState: BookingsListSortState = {
  sortColumn: null,
  sortDirection: 'desc',
};

export function toggleBookingsListSort(prev: BookingsListSortState, column: BookingsToEditSortColumn): BookingsListSortState {
  if (prev.sortColumn === column) {
    return { ...prev, sortDirection: prev.sortDirection === 'asc' ? 'desc' : 'asc' };
  }
  return { sortColumn: column, sortDirection: 'desc' };
}
